import { createContext } from 'react';
import { DashboardIPConsultsCOMContextProps } from './DashboardIPConsultsCOM.types';

export const DashboardIPConsultsCOMContext = createContext<DashboardIPConsultsCOMContextProps>(
  {} as DashboardIPConsultsCOMContextProps
);
